import api from '@/services/api';

const API_URL = '/credit-card';

class PanstarPayService {
  async getPanstarPayCardList(token) {
    try {
      const response = await api.get(`${API_URL}/web`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      return response;
    } catch (error) {
      throw error;
    }
  }

  async selectPaymentCardOnBoard(params, token) {
    try {
      const response = await api.patch(`${API_URL}/web/main-card`, params, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new PanstarPayService();
